import { Chart } from "chart.js/auto";
import formatSecondsToHMS from "../../../helpers/formatSecondsToHMS";
import grandingResult3d from "../../../stories/assets/granding-result-3d-icon.svg";
import grandingRecord3d from "../../../stories/assets/granding-record-3d-icon.svg";
import { TopikTestContext } from "./TakeTest";
import { useContext, useEffect, useRef, useState } from "react";
import QUESTION_TYPE from "../../../constants/question-type";
import { getTopikTestResultDetailByUserId } from "../../../services/quizService";
import { getCurrentUserFromLocalStorage } from "../../../helpers/localStorageHelper";

export default function TopikTestResult({ props }) {
  const { translation } = useContext(TopikTestContext);
  const [resultDetailData, setResultDetailData] = useState([]);
  const [showReadingDataChart, setShowReadingDataChart] = useState(null);
  const [showListeningDataChart, setShowListeningDataChart] = useState(null);

  const [user] = useState(() => {
    const currentUser = getCurrentUserFromLocalStorage();
    return currentUser;
  });

  useEffect(() => {
    setTimeout(() => {
      const content = document.querySelector(".p-dialog-content");
      if (content) {
        content.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 100);
    const getTopikTestResultDetail = async () => {
      const data = await getTopikTestResultDetailByUserId();
      setResultDetailData(data);
    };
    getTopikTestResultDetail();
  }, []);

  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);

  const chartRef2 = useRef(null);
  const chartInstanceRef2 = useRef(null);

  const processStatistics = (statistics) => {
    if (!statistics) return [0, 0, 0, 0];
    const result = [...statistics];
    while (result.length < 4) {
      result.push(0);
    }
    return result;
  };

  useEffect(() => {
    const readingStatistic = resultDetailData?.find((item) => item?.quizCategory === QUESTION_TYPE.READING)?.statistics;
    const listeningStatistic = resultDetailData?.find((item) => item?.quizCategory === QUESTION_TYPE.LISTENING)?.statistics;

    if (!readingStatistic || !readingStatistic?.length) {
      setShowReadingDataChart(null);
    } else {
      setShowReadingDataChart(readingStatistic);
    }

    if (!listeningStatistic || !listeningStatistic?.length) {
      setShowListeningDataChart(null);
    } else {
      setShowListeningDataChart(listeningStatistic);
    }
  }, [resultDetailData]);

  useEffect(() => {
    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }

    if (chartRef.current) {
      const ctx = chartRef.current.getContext("2d");

      chartInstanceRef.current = new Chart(ctx, {
        type: "bar",
        data: {
          labels: [translation?.column1ChartTitle, translation?.column2ChartTitle, translation?.column3ChartTitle, translation?.column4ChartTitle],
          datasets: [
            {
              data: processStatistics(showReadingDataChart),
              backgroundColor: ["#FF9A40", "#FF9A40", "#FF9A40", "#66EEBA"],
              borderRadius: 15,
              borderSkipped: false,
              barPercentage: 0.9,
              categoryPercentage: 0.9,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: { display: false },
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
            },
            y: {
              grid: {
                display: false,
              },
              beginAtZero: true,
              max: 100,
              ticks: {
                stepSize: 25,
              },
            },
          },
        },
      });
    }
  }, [showReadingDataChart]);

  useEffect(() => {
    if (chartInstanceRef2.current) {
      chartInstanceRef2.current.destroy();
    }

    if (chartRef2.current) {
      const ctx2 = chartRef2.current.getContext("2d");

      chartInstanceRef2.current = new Chart(ctx2, {
        type: "bar",
        data: {
          labels: [translation?.column1ChartTitle, translation?.column2ChartTitle, translation?.column3ChartTitle, translation?.column4ChartTitle],
          datasets: [
            {
              data: processStatistics(showListeningDataChart),
              backgroundColor: ["#FF9A40", "#FF9A40", "#FF9A40", "#66EEBA"],
              borderRadius: 15,
              borderSkipped: false,
              barPercentage: 0.9,
              categoryPercentage: 0.9,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: {
            legend: { display: false },
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
            },
            y: {
              grid: {
                display: false,
              },
              beginAtZero: true,
              max: 100,
              ticks: {
                stepSize: 25,
              },
            },
          },
        },
      });
    }
  }, [showListeningDataChart]);

  return (
    <div className="mt-5">
      <div className="flex align-content-center mb-3 gap-2">
        <img src={grandingRecord3d} alt="" />
        <h5 className="keduall-typography heading-h5-semibold-600 text-third-text-color">{translation.testResultTitle}</h5>
      </div>
      <h3 className="keduall-typography heading-h3-semibold-600 text-primary-txt-color mb-075 text-center">{translation.congratsTitle}</h3>
      <div className="flex justify-content-center align-content-center mb-3">
        <h5 className="keduall-typography heading-h5-normal-400 text-default-txt-color">
          {`${translation.currentLevelTitle}: `}
          <span className="keduall-typography heading-h5-bold-700 text-primary-txt-color">{props?.selectedTopikLevelName}</span>
        </h5>
      </div>
      {props?.selectedTest?.quizSkillsCode !== QUESTION_TYPE.WRITING && (
        <>
          <div className="flex pre-test-result-score border w-full flex-wrap">
            <div className="result-item">
              <p className="keduall-typography text-16-normal-400 text-dark-txt">{translation.questionTypeTitle}</p>
              <h4 className="keduall-typography heading-h4-normal-400 text-default-txt-color">
                {props?.selectedTest?.quizSkillsCode === QUESTION_TYPE.READING
                  ? translation?.reading
                  : props?.selectedTest?.quizSkillsCode === QUESTION_TYPE.LISTENING
                  ? translation?.listening
                  : translation?.writing}
              </h4>
            </div>
            <div className="result-item">
              <p className="keduall-typography text-16-normal-400 text-dark-txt">{translation.scoreTitle}</p>
              <h4 className="keduall-typography heading-h4-bold-700 text-primary-txt-color">{props?.currentResultData?.testScore}</h4>
            </div>
            <div className="result-item">
              <p className="keduall-typography text-16-normal-400 text-dark-txt">{translation.totalQuestionTitle}</p>
              <h4 className="keduall-typography heading-h4-normal-400 text-default-txt-color">{props?.currentResultData?.totalQuestion}</h4>
            </div>
            <div className="result-item">
              <p className="keduall-typography text-16-normal-400 text-dark-txt">{translation.correctQuestionTitle}</p>
              <h4 className="keduall-typography heading-h4-normal-400 text-default-txt-color">{props?.currentResultData?.totalCorrectAnswer}</h4>
            </div>
            <div className="result-item">
              <p className="keduall-typography text-16-normal-400 text-dark-txt">{translation.wrongQuestionTitle}</p>
              <h4 className="keduall-typography heading-h4-normal-400 text-default-txt-color">
                {isNaN(props?.currentResultData?.totalQuestion - props?.currentResultData?.totalCorrectAnswer)
                  ? ""
                  : props?.currentResultData?.totalQuestion - props?.currentResultData?.totalCorrectAnswer}
              </h4>
            </div>
            <div className="result-item">
              <p className="keduall-typography text-16-normal-400 text-dark-txt">{translation.correctRateTitle}</p>
              <h4 className="keduall-typography heading-h4-normal-400 text-default-txt-color">{props?.currentResultData?.testPercent}</h4>
            </div>
            <div className="result-item">
              <p className="keduall-typography text-16-normal-400 text-danger">{translation.timeTakenTitle}</p>
              {props?.currentResultData?.testTime && (
                <h4 className="keduall-typography heading-h4-normal-400 text-default-txt-color">{formatSecondsToHMS(props?.currentResultData?.testTime)}</h4>
              )}
            </div>
          </div>
          {!!user?.id && (
            <>
              <div className="flex align-content-center my-5 gap-2">
                <img src={grandingResult3d} alt="" />
                <h5 className="keduall-typography heading-h5-semibold-600 text-third-text-color">{translation.testResultDetailTitle}</h5>
              </div>
              <div className="topik-test-result-detail mb-075">
                <div className="topik-test-result-detail-content">
                  <div className="topik-test-result-detail-header">
                    <div className="flex pre-test-result-score w-full">
                      <div className="result-item">
                        <p className="keduall-typography text-16-normal-400 text-dark-txt">{translation.questionTypeTitle}</p>
                      </div>
                      <div className="result-item">
                        <p className="keduall-typography text-16-normal-400 text-dark-txt">{translation.scoreTitle}</p>
                      </div>
                      <div className="result-item">
                        <p className="keduall-typography text-16-normal-400 text-dark-txt">{translation.totalQuestionTitle}</p>
                      </div>
                      <div className="result-item">
                        <p className="keduall-typography text-16-normal-400 text-dark-txt">{translation.correctQuestionTitle}</p>
                      </div>
                      <div className="result-item">
                        <p className="keduall-typography text-16-normal-400 text-dark-txt">{translation.wrongQuestionTitle}</p>
                      </div>
                      <div className="result-item">
                        <p className="keduall-typography text-16-normal-400 text-dark-txt">{translation.correctRateTitle}</p>
                      </div>
                      <div className="result-item">
                        <p className="keduall-typography text-16-normal-400 text-danger">{translation.timeTakenTitle}</p>
                      </div>
                    </div>
                  </div>
                  {resultDetailData.map((result, index) => (
                    <div key={index} className="flex pre-test-result-score w-full">
                      <div className="result-item">
                        <h4 className="keduall-typography heading-h4-normal-400 text-default-txt-color">
                          {result?.quizCategory === QUESTION_TYPE.READING
                            ? translation?.reading
                            : result?.quizCategory === QUESTION_TYPE.LISTENING
                            ? translation?.listening
                            : translation?.writing}
                        </h4>
                      </div>
                      <div className="result-item">
                        <h4 className="keduall-typography heading-h4-bold-700 text-primary-txt-color">{result?.testScore}</h4>
                      </div>
                      <div className="result-item">
                        <h4 className="keduall-typography heading-h4-normal-400 text-default-txt-color">{result?.totalQuestion}</h4>
                      </div>
                      <div className="result-item">
                        <h4 className="keduall-typography heading-h4-normal-400 text-default-txt-color">{result?.totalCorrectAnswer}</h4>
                      </div>
                      <div className="result-item">
                        <h4 className="keduall-typography heading-h4-normal-400 text-default-txt-color">
                          {isNaN(result?.totalQuestion - result?.totalCorrectAnswer) ? "" : result?.totalQuestion - result?.totalCorrectAnswer}
                        </h4>
                      </div>
                      <div className="result-item">
                        <h4 className="keduall-typography heading-h4-normal-400 text-default-txt-color">{result?.testPercent}</h4>
                      </div>
                      <div className="result-item">
                        <h4 className="keduall-typography heading-h4-normal-400 text-default-txt-color">{formatSecondsToHMS(result?.testTime)}</h4>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="topik-test-result-detail-chart pt-3 mb-5 flex flex-wrap gap-7 justify-content-center align-items-center">
                {showReadingDataChart && (
                  <div className="topik-test-result-detail-chart-item">
                    <p className="keduall-typography text-16-normal-400 text-dark-txt mb-4">{translation?.readingChartTitle}</p>
                    <canvas ref={chartRef} width={300} height={260}></canvas>
                  </div>
                )}
                {showListeningDataChart && (
                  <div className="topik-test-result-detail-chart-item">
                    <p className="keduall-typography text-16-normal-400 text-dark-txt mb-4">{translation?.listeningChartTitle}</p>
                    <canvas ref={chartRef2} width={300} height={260}></canvas>
                  </div>
                )}
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}
